import { formatNumber, formatCurrency, formatDate, DatePipe, CurrencyPipe, DecimalPipe } from '@angular/common';
import { ElementRef, EventEmitter, inject } from '@angular/core';
import * as moment from 'moment';
import { getDocumentNumber as getDocNum, mongoId } from '../../../../@core/common/global';
import { ApiService } from '../../../../@core/service/api.service';
import { BusinessModel, BusinessUnitModel, UserModel } from '../../../../@models';
import { ActionPointData, CompilationTypeData, DeliveryConditionsData, DocumentStatusData,
  InvoicePaymentData, IssuerData, MeansOfTransportationData,
  OfferStatusData, PaymentStatusData, UnitData } from '../../../../@models/erp/compilationData';
import { DownloadConfig } from '../../document/document-printer/document-printer.component';
import * as saveAs from 'file-saver';
import { AuthGuardService } from '../../../../@core/service/auth-guard.service';
import { SharedDataService } from '../../../../@core/service/shared-data.service';
import { LineItemPfspoSelectorComponent } from '../../document/line-item-container/line-item-pfspo-selector/line-item-pfspo-selector.component';

export abstract class CommonPrinter {

  abstract search: any;
  // abstract businesses: BusinessModel[];
  // abstract businessUnits: BusinessUnitModel[];
  // abstract users: UserModel[];
  abstract done: EventEmitter<any>;
  abstract back: EventEmitter<void>;

  // loading = true;
  public get loading() { return this.data?.reportIsLoading }
  public set loading(l: boolean) { if (this.data) this.data.reportIsLoading = l }

  query: any = {}; // -> this.search.{subobject from ReportsComponent::report}
  error: string;
  user: UserModel;
  pdfData = null;
  xlsData = null;

  private elementRef: ElementRef;
  private apiService: ApiService;
  private authService: AuthGuardService;
  public data: SharedDataService;

  constructor(ref: ElementRef, api: ApiService, auth: AuthGuardService, data: SharedDataService) {  
    this.elementRef = ref;
    this.apiService = api;
    this.authService = auth;
    this.data = data;
  }

  init() {
    this.pdfData = [];
    this.xlsData = { header: [], table: [] };
    this.loading = false;
    this.error = null;
    this.authService.loadMe().then(user => {
      this.user = user
    })
  }

  // init(search: any, businesses: BusinessModel[], businessUnits: BusinessUnitModel[], users: UserModel[]) {
  //   this.search = search;
  //   this.businesses = businesses;
  //   this.businessUnits = businessUnits;
  //   this.users = users;
  // }

  now = () => new Date();

  formatDate(date) {
    if (!date || date < 0) return 'All';
    const datePipe = new DatePipe('de');
    return datePipe.transform(date, 'yy-MM-dd');
  }

  getIssuer = (num: number) => +num === 3 ? 'NRKG' : 'NRKA';

  getBusinessName = (id: string) => (this.data.businesses.find(f => f._id === id) || {})['name'];
  getBusinessNames = (ids: string[]) => {
    const bs = ((this.data.businesses.filter(f => ids.includes(f._id)) || []).map(m => m.name) || [])
    return bs && bs.join(', ');
  }

  getBusinessUnitName = (id: string) => (this.data.businessUnits.find(f => f._id === id) || {})['name'];
  getBusinessUnitNames = (ids: string[]) => {
    const bs = ((this.data.businessUnits.filter(f => ids.includes(f._id)) || []).map(m => m.name) || [])
    return bs && bs.join(', ');
  }

  getUserName(id: string) {
    const user = this.data.users.find(u => u.contact && u.contact._id === id);
    return user && user.contact.title;
  }

  getMeansOfTransportation = (id: number) => id > 0 ? MeansOfTransportationData.get(id).name : '';

  getDocumentNumber(item: any, asLink = false) {
    const  full = location.protocol+'//'+location.hostname+(location.port ? ':'+location.port: '');
    if (asLink) return `${full}/#/pages/erp/document/nrka?code=${item.code}`
    if (item.documentNumber) return item.documentNumber;
    return getDocNum(item);
  }

  getTextFromArray(arr: any[], model: any[], field = 'name') {
    return model.filter(f => arr.includes(f._id)).map(m => m[field]).join(', ');
  }

  getLink(hyperlink: string, asText = false) {
    // if (!asText) return hyperlink.replace(/=HYPERLINK\("(.+)"\s*,.*\)/, '$1');
    // return hyperlink.replace(/=HYPERLINK\(.+,\s*"(.*)"\)/, '$1');
    // console.log('link', hyperlink, asText);
    let textlink = hyperlink && typeof hyperlink.split === 'function' && hyperlink.split(';');
    let issuer = /NRKG/.test(hyperlink) ? 'nrkg' : 'nrka';
    return asText ? textlink && textlink[0] || '' : `/#/pages/erp/document/${issuer}?code=${textlink && textlink[1] || ''}`;
  }    // for (const pdf of ['offers', 'orders', 'noninvoiced', 'dueinvoices']) await this.generateReport(pdf);

  getUnit(id: number) {
    if (!id) return '';
    return UnitData.get(id).short;
  }

  getOfferStatus(status: number[]) {
    // if (!+id) return '';
    // return OfferStatusData.get(+id).name;
    return OfferStatusData.getStati().filter(f => status?.[f.id]).map(m => m.name).join(', ');
  }

  getSelectedItems(fields: any) {
    // const docs = this.search.lastinvoices && this.search.lastinvoices.docs;
    return fields && Object.keys(fields).filter(f => fields[f]).map(m => m.toUpperCase()).join(', ')
  }

  getPaymentStatus() {
    const status = this.search.dueinvoices && this.search.dueinvoices.invoiceStatus;
    return status && Object.keys(status).filter(f => status[f]).join(', ').replace(/([A-Z])/g, ' $1').toLowerCase();
  }

  getValue(row: any, name: string, pdf = true, idx = 0) {
    if (row.empty) return;
    
    let ret = row[name];
    if (name?.indexOf('.') >= 0) {
      const params = name.split('.');
      if (pdf) {
        ret = row[params[1]] || '';
      } else {
        ret = row[params[0]] && row[params[0]][params[1]] ? row[params[0]][params[1]] : '';
      }
    }



    if (name === 'firstDate.issueDate') {
      // console.log('firstDate.issueDate', row);
    }

    // calced in backend
    // if (doc && doc.invoicePayment
    //   && (name === 'lineItems.piecePrice' || name === 'lineItems.price' || name === 'lineItems.net')) {

    //   ret = ret * row['invoicePercent'] / 100;
    // }

    if (/lineItems\.extra/.test(name)) {
      // console.log(name, ret, name.split('.')[2], );
      ret = ret[idx][name.split('.')[2]];
    }

    // console.log('ret', ret, ret.text);

    // if (ret?.text !== undefined) {
    //   ret = ret.text;
    // }

    // console.log('ret2', ret);

    switch (name) {
      case 'customerReference':
        return this.data?.businesses?.find(f => mongoId(ret) === mongoId(f))?.name || '';
      case 'customerDocumentNumber':
        // return row['customerDocumentDate'] && (!this.search.orders && !this.search.offers) ? `${ret} (${new Date(row['customerDocumentDate']).toISOString().replace(/T.*/,'').replace(/\-/g, '‑')})` : ret;
        return ret;
      case 'customerDoc':
        return row['customerDocumentNumber'];
      case 'type':
        const t = CompilationTypeData.get(ret);
        return t ? t.name : '';
      case 'documentStatus':
        const s = DocumentStatusData.get(ret);
        return s ? s.name : '';
      case 'issuer':
        if (row['nrkjOverride']) return 'NRKJ'
        const i = IssuerData.get(ret);
        return i ? i.name : '';
      case 'meansOfTransportation':
        const motd = MeansOfTransportationData.get(ret);
        return motd ? motd.name : '';
      case 'deliveryConditions':
        const dd = DeliveryConditionsData.get(ret);
        return dd ? dd.name : '';
      case 'paymentStatus':
        const ps = PaymentStatusData.get(ret);
        return ps ? ps.name : '';
      case 'lineItems.productName':
        // console.log('row', row.externalCode);
        if (/*this.getType() === 'noninvoiced' &&*/ row.externalCode) return ret + '\n' + row.externalCode;
        return ret;
      case 'lineItems.trial': 
        const product = this.data.finishedProducts.find(f => mongoId(f) === row['lineItems']['fp'])?.product;
        return product?.trial || '';
      case 'lineItems.unit':
      case 'displayUnit':
        const lu = UnitData.get(ret);
        return lu ? lu.short : '';
      case 'lineItems.quantity':
      case 'lineItems.displayUnitQuantity':
      case 'lineItems.m2':
        return pdf ? formatNumber(ret, 'de', '1.0-2') : Math.round(ret*1e10)/1e10;
      case 'lineItems.weight':
        return pdf ? formatNumber(ret, 'de', '1.2-2') + ' kg' : Math.round(ret*1e10)/1e10;
      case 'lineItems.price':
      case 'lineItems.piecePrice':
      case 'displayUnitPrice':
      case 'piecePrice':
      case 'value':
        return pdf ? formatCurrency(ret, 'de', '€', null, '1.2-3') : Math.round(ret*1e10)/1e10;
      case 'lineItems.net':
      case 'totalPrice':
        return pdf ? formatCurrency(ret, 'de', '€', null, '1.2-2') : Math.round(ret*1e10)/1e10;
      case 'lineItems.partialDelivery':
        if (['PFSPO', 'SPO'].includes(CompilationTypeData.get(row.type)?.code) && !/^OBIC/.test(row.parent)) return '';
        if (row.lineItems?.li_partdel) row.li_partdel = row.lineItems.li_partdel;
        return `${row.li_partdel?.num}/${row.li_partdel?.sum}`;
      case 'createdAt':
      case 'issueDate':
      case 'spInvoiceDate':
      case 'dueDate':
      case 'lastDueUpdate':
      case 'vieDispatchDate':
      case 'dispatchDate':
      case 'expectedNextInvoiceDate':
      case 'nextPaymentDate':
      case 'paymentDate':
      case 'dateOfDispatch':
      case 'customerReqDate':
      case 'customerAccDate':
      case 'customerDocumentDate':
      case 'actualDeliveryDate':
      case 'readyForPickup':
      case 'dateOfPickup':
      case 'etaCustomer':
      case 'etaCustomerDate':
      case 'dateOfETA':
      case 'dateOfDelivery':
      case 'dateOfFAT':
      case 'dateOfSAT':
      case 'endOfWarranty':
      case 'dateOfDrawings':
      case 'dateOfSourcing':
      case 'etaDate':
      case 'exwDate':
      case 'exwJapanDate':
      case 'internalExwDate':
      case 'firstExwDate':
      case 'firstIssueDate':
      case 'priceDate':
      case 'validFrom':
      case 'validTo':
      case 'arrivalDate':
      case 'arrivingVieDate':
      case 'offerValidity':
      case 'updatedAt':
      case 'lineItems.dateOfDelivery':
      case 'lineItems.extra.issueDate':
      case 'lineItems.extra.customerAcceptedDeliveryDate':
      case 'lineItems.extra.vieDispatchDate':
      case 'lineItems.extra.dateOfDispatch':
      case 'lineItems.extra.exwJapanDate':
      case 'lineItems.extra.exwDate':
      case 'lineItems.extra.internalExwDate':
      case 'lineItems.extra.customerRequestedDeliveryDate':
      case 'lineItems.extra.arrivingVieDate':
      case 'lineItems.extra.dateOfVieArrival':
      case 'lineItems.extra.etaCustomerDate':
      case 'lineItems.extra.dateOfDelivery':
      case 'shelfLifeDate':
      case 'shelfLifeDateOverride':
      case 'rfqDate':
        return ret && typeof ret === 'string' ? ret.replace(/T.*/,'') : '';
      case 'lineItems.extra.calcName':
        const issr = row.extra[idx]['code'].replace(/.*(NRK.).*/, '$1'); // TODO: get issuer string
        return pdf ? [ret + (row.extra[idx]['obic'] ? ' '+row.extra[idx]['obic'] : ''), row.extra[idx]['code'], issr && issr.toLowerCase()] : ret;
      case 'lineItems.extra.quantity':
        if (+row.extra[idx]['totalQuantity'] !== +ret) return row.extra[idx]['totalQuantity'] ? ret + '/' + row.extra[idx]['totalQuantity'] : ret;
        return ret;
      case 'li_popos': 
        // return ret === -2 ? '-' : ( ret > 0 ? ret-1 : '');
        return ret;
      case 'li_partdel': return row['li_popos'] === -2 ? '-' : ret;
      case 'productName':
        const cn = row['calculatedName'] && row['calculatedName'].split(';');
        return cn && cn[0] && cn[0].trim();
      case 'dimensions':
        const dim = row['calculatedName'] && row['calculatedName'].split(';');
        return dim && dim[1] && dim[1].trim();
      case 'fpCustomerCode':
        return row.fp?.externalCode || '';
      case 'fpCode':
        const fpc = row['lineItems']['productName'] && row['lineItems']['productName'].split(';');
        return fpc && fpc[0] && fpc[0].trim();
      case 'fpName':
        const fpn = row['lineItems']['productName'] && row['lineItems']['productName'].split(';');
        return fpn && fpn[1] && fpn[1].trim();
      case 'fpDimensions':
        const fpd = row['lineItems']['productName'] && row['lineItems']['productName'].split(';');
        return fpd && fpd[2] && fpd[2].trim();
      case 'documentNumber':
        // return ret;
        // const version = /(IN|PFIN|CN|PFCN)/.test(row['code']) ? '' : `VS${row['version']}`
        // const text = ret ? ret : row['code'] + version;
        if (row['invoicePayment'] && row['invoicePercent']) {
          ret = `${ret} (${InvoicePaymentData.get(row['invoicePayment']).code} ${row['invoicePercent']}%)`
        }
        // return pdf ? ret : ret + ';' + row['code'];
        // const  full = location.protocol+'//'+location.hostname+(location.port ? ':'+location.port: '');
        // const link = `${full}/#/pages/erp/document/nrka?code=${row['code']}`;
        const issuer = row['code']?.replace(/.*(NRK.).*/, '$1'); // TODO: get issuer string
        if (ret) return pdf ? [ret, row['code'], issuer && issuer.toLowerCase()] : ret + ';' + row['code'];
        // const  full = location.protocol+'//'+location.hostname+(location.port ? ':'+location.port: '');
        // const link = `${full}/#/pages/erp/document/nrka?code=${row['code']}`;
        // return `=HYPERLINK("${link}", "${ret}")`
        return '';
      case 'free/assigned':
        return row['ocYesNo'] === 'no' ? row['freeQ'] || '' : row['assignedQ'] || '';
      case 'relatedCS':
        if (ret === undefined || ret === 'undefined') return '';
        return pdf ? [ret, row['csCode'], 'nrka'] : ret + ';' + row['csCode'] || ret || '';
      case 'invoiceStatus':
        // return ['','𐄂','☐','🗹'][ret] || '𐄂'; // null, not paid, paritally paid, fully paid
        return ['','NP','PP','FP'][ret] || 'x'; // null, not paid, paritally paid, fully paid
      case 'dispatchDateUnconfirmed':
        return ret ? 'NC' : '';
      case 'actionPoint':
        return ret > 0 ? ActionPointData.get(ret) && ActionPointData.get(ret).name : '';
      case 'offerStatus':
        return ret > 0 ? OfferStatusData.getName(ret) : '';
      case 'statusComment':
        return ret > 0 ? OfferStatusData.getName(ret, row['offerStatus']) : '';
      case 'completelyInvoiced':
        if (row['code'] && /OCNRK/.test(row['code'])) return ret ? 'IN ok' : 'No IN';
        // if (row['code'] && /INNRK/.test(row['code'])) return ret ? ['','NP','PP','FP'][ret] : '';
        // return (row['code'] && /OCNRK/.test(row['code']) && ret ? 'o' : 'x') || '';
        return '';
      case 'transportStatus':
      case 'spoTransportStatus':
        return ['', 'planned', 'en route', 'completed'][ret];
      case 'spoStatus':
        return ['unconfirmed','confirmed','completed'][ret];
      case 'availabilityStatus':
        return ['', 'not completed', 'completed'][ret];
      case 'accounting':
        return ['selling', 'buying'][ret];
      case 'orNotCompleted':
        return ret ? 'not completed' : 'completed'
      case 'issuedBy':
      case 'dueUser':
        return this.data.userShort(ret);
      case 'dueOverdue':
        const overdue = moment(new Date(row['dueDate'])).diff(moment(new Date()), 'days') < 0
        const grace = moment(new Date(row['dueDate'])).diff(moment(new Date()), 'days') >= -7
        return overdue && grace ? 'grace' : overdue ? 'overdue' : 'due';
      case 'testCertificate':
      case 'proveOfDelivery':
      case 'transactionReceipt':
        return ret?.completed ? 'yes' : 'no';
      case 'fiscalYear':
      case 'spInvoiceDateFiscalYear':
        return ret ? `${ret}/${(+ret+1) % 100}` : '';
      case 'pmntDueDiff':
        if (!row['paymentDate']) return '';
        const pmt = moment(row['paymentDate']).startOf('day');
        const due = moment(row['dueDate']).startOf('day');
        const diff = pmt.diff(due, 'days')
        return isNaN(diff) ? '' : diff;
      case 'customerProductSpecification':
        return Array.isArray(ret) ? ret.map(m => m.name).join(',') : ''
      case 'customerIdentificator':
        return ret?.name || ''
      // { name: 'openValue', header: 'Remaining OC Value' },
      // { name: 'invoicesPaid', header: 'All OC paid' },
      // { name: 'spoOpenValue', header: 'Remaining SPO Value' },        
      case 'openValue':
      case 'spoOpenValue':
        return ret === 0 ?  'yes' : 'no';
        // return ret === 0 ?  {text: 'yes'} : {text: 'no'};
      case 'invoicesPaid':
        return ret ? 'yes' : 'no';
      case 'baseProductsNet':
        return ret?.toFixed(2).replace('.', ',') || ''; // new DecimalPipe('de').transform(ret, '1.2-2');
      case 'boxStatus':
        return ['free', 'assigned', 'assigned', 'invoiced', 'damaged', 'lost'][+ret];
    }

    if (name?.match(/^per/) && ret > 0) return formatCurrency(ret, 'de', '€', null, '1.2-3');

    // if (row[name]?.text !== undefined) {
    //   row[name].text = ret;
    //   return row[name];
    // }

    // console.log('get data', row, name, ret);


    return ret;
  }

  getType = () => this.search && Object.keys(this.search)[0]; // subobject from ReportsComponent::report

  static getPDFFilename(type, search, data = null) {
    if (search[type]?.filename) return search[type].filename;
    let code = 'LINNRK'
    switch (type) {
      case 'offers': code = 'OFNRK'; break;
      case 'noninvoiced': code = 'OCNRK'; break;
      case 'orders': code = 'ORNRK'; break;
      case 'dueinvoices': code = 'DINNRK'; break;
      case 'openspo': code = 'PFSPO'; break;
      case 'invoiced': code = 'INNRK'; break;
      case 'openorders': code = 'OONRK'; break;
      case 'customeroverview': code = 'BONRK'; break;
      case 'deliverynotes': code = 'DINNRK'; break;
      case 'boxes': code = 'BRNRK'; break;
      case 'inventory': code = 'BINRK'; break;
      case 'cs': code = 'GSNR_Overview'; break;
    }
    let date = formatDate(Date.now(), 'yyMMdd', 'en_US');
    if (search[type]?.extended === 11) code = `inventory_${moment(search[type].date).format('YYMM')}`;
    if (search[type]?.quickLink) date = 'CW' + (search[type]?.quickLink === 1 ? moment().subtract(1, 'week') : moment()).format('WW');
    if (search[type]?.nameOverride) date = search[type].nameOverride;
    // console.log('getPDFFilename', data);
    if (type === 'openspo' && search[type]?.combinedShipment && data?.map?.[0]) {
      const line = data.map[0];
      return `${date} ${line.recipient} ${line.exwDate?.replace(/-/g, '').replace(/20(.*)T.*/, '$1') || ''} ${line.meansOfTransport} ${line.relatedCS}`;
    }
    return `${date}_${code}`
  }

  getFilename(data = null) {
    const type = this.getType();
    return CommonPrinter.getPDFFilename(type, this.search, data);
  }

  async downloadPdf(type: string = null) {
    let overflow = 0;
    while (this.loading && overflow++ < 400) {  // 40s timeout
      await new Promise(r => setTimeout(r, 100));
    }
    // console.log('on download pdf')
    await this.onDownloadPdf();
  }

  async downloadExcel(type: string = null) {
    let overflow = 0;
    while (this.loading && overflow++ < 200) {  // 20s timeout
      await new Promise(r => setTimeout(r, 100));
    }
    await this.onDownloadExcel();
  }

  onDownloadPdf() {
    console.log('on download pdf');
    return new Promise<void>(resolve => {
      const config = new DownloadConfig;
      config.html = this.elementRef.nativeElement.innerHTML.replace(/ style="[^"]*"/, ''); // clear container style attribute (scaling from getStyle())
      config.css = 'reports-printer.css';
      config.orientation = this.query.orientation === 'portrait' ? 'Portrait' : 'Landscape';
      setTimeout(() => resolve(), 20000); // 20s timeout
      this.apiService.getDocumentFile('/api/v1/document_report/pdf', config).subscribe(res => {
        saveAs(res, this.getFilename() + '.pdf')
        resolve();
      });
    });
  }

  onDownloadExcel(special = this.query.special ?? 0) {
    return new Promise<void>(resolve => {
      const config = new DownloadConfig;

      // filter hidden columns
      const data = Object.assign({}, this.xlsData);
      // console.log('special===============================================', this.query?.special);

      if (data.table.sheets) {
        data.table.sheets = data.table.sheets.map(sheet => ({
          name: sheet.name,
          data: sheet.data.map(row => row.filter((col, idx) => !data.header[idx].hidden))
        }))
        // console.log('sheets', this.xlsData.xls.sheets);
      } else if (!special) {
        data.table = this.xlsData.xls.map(row => row.filter((col, idx) => !this.xlsData.header[idx].hidden && this.xlsData.header[idx].special !== 1))
      } else {
        data.table = this.xlsData.xls.map(row => row.filter((col, idx) => !this.xlsData.header[idx].hidden && this.xlsData.header[idx].special >= 1))
      }
      if (!special) {
        data.header = this.xlsData.header.filter(col => !col.hidden && col.special !== 1);
      } else {
        data.header = this.xlsData.header.filter(col => !col.hidden && col.special >= 1);
      }
      data.heading = this.xlsData.heading;

      // console.log('data', data, this.getFilename());
      
      config.table = JSON.stringify(data);

      setTimeout(() => resolve(), 20000); // 20s timeout
      this.apiService.getDocumentFile('/api/v1/document_report/xls', config).subscribe(async res => {
        saveAs(res, this.getFilename(data) + '.xlsx')
        resolve();
      });
      this.done.emit('done');
    });
  }

  onClosePreview() {
    this.back.emit();
  }

}
